<template>
  <div
      class="news-editor-page"
      v-loading="loading"
      element-loading-text="正在保存中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">{{ params.id ? '编辑企业内容' : '新建企业内容' }}</h2>
        <p class="page-desc">填写左侧基础信息，在右侧编辑正文内容</p>
      </div>
      <el-button
          class="save-btn"
          :type="params.id ? 'warning' : 'primary'"
          icon="el-icon-check"
          @click="doConfirm"
      >{{ params.id ? '保存修改' : '保存内容' }}</el-button>
    </div>

    <div class="parent">
      <div class="child left">
        <el-form label-position="top" :model="params" class="news-form">
          <el-collapse v-model="activeCollapse" class="form-collapse">

            <el-collapse-item title="基本信息" name="basic">
              <el-form-item label="标题" prop="title">
                <el-input v-model="params.title" clearable type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="255" placeholder="请输入标题"/>
              </el-form-item>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="标题颜色" prop="titleColor">
                    <el-color-picker v-model="params.titleColor" show-alpha/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="企业类型" prop="newsTypeId">
                    <el-cascader
                        :options="newsTypes"
                        :props="{ checkStrictly: true }"
                        :value="params.newsTypeId"
                        clearable
                        placeholder="请选择类型"
                        style="width: 100%"
                        @change="newsTypeChange"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="发布时间" prop="datetime">
                    <el-date-picker
                        v-model="params.datetime"
                        placeholder="选择日期时间"
                        style="width: 100%"
                        type="datetime"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="区域" prop="area">
                    <el-cascader
                        v-model="params.areaDetailId"
                        :options="areaDetails"
                        :props="{ expandTrigger: 'hover' }"
                        clearable
                        filterable
                        placeholder="请选择区域"
                        style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="简介" prop="desc">
                <el-input v-model="params.desc" clearable type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="255" placeholder="请输入简介"/>
              </el-form-item>
            </el-collapse-item>

            <el-collapse-item title="标题与布局" name="title">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="固定顶部模板" prop="fixd">
                    <el-radio-group v-model="params.fixd" size="small">
                      <el-radio-button v-for="item in displays" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="锁定顶部" prop="fixdLock">
                    <el-radio-group v-model="params.fixdLock" size="small">
                      <el-radio-button v-for="item in displays" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="more-title-list">
                <div v-for="(moreTitle, i) in moreTitles" :key="i" class="more-title-item">
                  <div class="more-title-item__header">
                    <span class="more-title-item__label">副标题 {{ i + 1 }}</span>
                    <el-button class="danger-text" icon="el-icon-delete" type="text" @click="delMoreTitle(moreTitle)">删除</el-button>
                  </div>
                  <el-form-item label="标题">
                    <el-input v-model="moreTitle.title" maxlength="255" placeholder="请输入副标题"/>
                  </el-form-item>
                  <el-row :gutter="12">
                    <el-col :span="12">
                      <el-form-item label="颜色">
                        <el-color-picker v-model="moreTitle.color"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="独占一行">
                        <el-select v-model="moreTitle.display" placeholder="请选择" style="width: 100%">
                          <el-option v-for="item in displays" :key="item.value" :label="item.label" :value="item.value"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <el-button icon="el-icon-plus" plain size="small" type="primary" @click="addMoreTitle">添加副标题</el-button>
            </el-collapse-item>

            <el-collapse-item title="外观与封面" name="style">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="封面背景色" prop="coverColor">
                    <el-color-picker v-model="params.coverColor" show-alpha/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="内容背景色" prop="backColor">
                    <el-color-picker v-model="params.backColor" show-alpha/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="封面图片" prop="coverImg">
                <div class="avatar-uploader avatar-uploader--cover">
                  <el-upload
                      :action="fileBaseUrl"
                      :before-upload="beforeAvatarUpload"
                      :data="uploadData"
                      :on-success="handleAvatarSuccess"
                      :show-file-list="false"
                      accept="image/*"
                  >
                    <img v-if="params.coverImg" :src="params.coverImg" class="avatar avatar--cover">
                    <div v-else class="upload-placeholder">
                      <i class="el-icon-plus"/>
                      <span>上传封面</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-collapse-item>

            <el-collapse-item title="客服设置" name="service">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="显示客服二维码" prop="isShowServerQRCode">
                    <el-radio-group v-model="params.isShowServerQRCode" size="small">
                      <el-radio-button v-for="item in displays" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-tooltip content="点击右上角昵称 → 客服二维码，可上传默认二维码" placement="top">
                    <el-form-item label="使用默认二维码" prop="isDefaultServerQRCode">
                      <el-radio-group v-model="params.isDefaultServerQRCode" size="small">
                        <el-radio-button v-for="item in displays" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-form-item v-if="params.isDefaultServerQRCode=='否'" label="自定义客服二维码" prop="serverQRCode">
                <div class="avatar-uploader avatar-uploader--qrcode">
                  <el-upload
                      :action="fileBaseUrl"
                      :before-upload="beforeAvatarUpload"
                      :data="uploadData"
                      :on-success="ServerQRCodeHandleAvatarSuccess"
                      :show-file-list="false"
                      accept="image/*"
                  >
                    <img v-if="params.serverQRCode" :src="params.serverQRCode" class="avatar avatar--qrcode">
                    <div v-else class="upload-placeholder">
                      <i class="el-icon-plus"/>
                      <span>上传二维码</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-collapse-item>

            <el-collapse-item title="联系信息" name="contact">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="公司" prop="company">
                    <el-input v-model="params.company" clearable maxlength="50" placeholder="公司名称"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系人" prop="contact">
                    <el-input v-model="params.contact" clearable maxlength="50" placeholder="联系人姓名"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="座机" prop="fixedPhone">
                    <el-input v-model="params.fixedPhone" clearable maxlength="13" placeholder="座机号码"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机" prop="phone">
                    <el-input v-model="params.phone" clearable maxlength="11" placeholder="手机号码"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="网店" prop="onlineStore">
                <el-input v-model="params.onlineStore" clearable placeholder="网店链接或名称"/>
              </el-form-item>
              <el-form-item label="标题地点" prop="titleAddress">
                <el-input v-model="params.titleAddress" clearable placeholder="标题显示地点"/>
              </el-form-item>
            </el-collapse-item>

            <el-collapse-item title="内容插入" name="insert">
              <p class="section-tip">点击下方按钮插入内容到正文，相关字段可在下方预览</p>
              <div class="insert-toolbar">
                <el-button icon="el-icon-video-camera-solid" size="small" @click="onShowAddShipinhaoIndex">视频主页</el-button>
                <el-button icon="el-icon-video-camera" size="small" @click="onShowAddShipinhao">视频号</el-button>
                <el-button icon="el-icon-location-outline" size="small" @click="positioning">定位</el-button>
                <el-button icon="el-icon-mobile-phone" size="small" @click="onShowAddWeChatMP">小程序</el-button>
                <el-button icon="el-icon-link" size="small" @click="onShowAddOfficalAccountLink">公众号</el-button>
                <el-button icon="el-icon-coin" size="small" @click="onShowAddScoreLink">文本佣金</el-button>
                <el-button icon="el-icon-bank-card" size="small" @click="onShowAddCardScoreLink">卡片佣金</el-button>
                <el-button icon="el-icon-picture-outline" size="small" @click="onShowDialogUploadResourceCollections">图集</el-button>
              </div>
              <div class="insert-preview">
                <el-form-item label="视频主页">
                  <el-input v-model="videoIndex.linkText" clearable placeholder="点击上方按钮插入"/>
                </el-form-item>
                <el-form-item label="视频号">
                  <el-input v-model="video.linkText" clearable placeholder="点击上方按钮插入"/>
                </el-form-item>
                <el-form-item label="小程序">
                  <el-input v-model="weChatMP.text" clearable placeholder="点击上方按钮插入"/>
                </el-form-item>
              </div>
            </el-collapse-item>

          </el-collapse>
        </el-form>
      </div>

      <div class="child right">
        <div class="editor-panel">
          <div class="editor-panel__header">
            <span class="editor-panel__title">正文编辑</span>
            <span class="editor-panel__hint">手机预览宽度 375px</span>
          </div>
          <div class="editor-panel__body">
            <MyEditor
                ref="MyEditor"
                @cardScoreLinkClickListener="cardScoreLinkClickListener"
                @resourceCollectionsClickListener="resourceCollectionsClickListener"
            />
          </div>
        </div>
      </div>
    </div>


    <!--    插入微信小程序框-->
    <el-dialog
        title="插入小程序"
        :visible.sync="showAddWeChatMP"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addWeChatMP">
        <el-form-item label="AppId">
          <el-input
              clearable
              placeholder="请输入微信小程序的AppId"
              v-model="addWeChatMP.appid">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入微信小程序的链接文本"
              v-model="addWeChatMP.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addWeChatMP.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddWeChatMP = false">取 消</el-button>
        <el-button type="primary" @click="doAddWeChatMPTop">插入顶部</el-button>
        <el-button type="primary" @click="doAddWeChatMP">插入文章</el-button>
      </span>
    </el-dialog>

    <!--    插入视频号框-->
    <el-dialog
        title="插入视频号"
        :visible.sync="showAddShipinhao"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addShipinhao">
        <el-form-item label="视频号ID">
          <el-input
              clearable
              placeholder="请输入视频号ID"
              v-model="addShipinhao.finderUserName">
          </el-input>
        </el-form-item>
        <el-form-item label="视频ID">
          <el-input
              clearable
              placeholder="请输入视频ID"
              v-model="addShipinhao.feedId">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入视频号的链接文本"
              v-model="addShipinhao.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addShipinhao.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddShipinhao = false">取 消</el-button>
        <el-button type="primary" @click="doAddShipinhaoTop">插入顶部</el-button>
        <el-button type="primary" @click="doAddShipinhao">插入文章</el-button>
      </span>
    </el-dialog>

    <!--    插入公众号链接-->
    <el-dialog
        title="插入公众号链接"
        :visible.sync="showAddOfficalAccountLink"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addOfficalAccountLink" ref="addOfficalAccountLinkForm">
        <el-form-item label="链接" prop="src"
                      :rules="[
                        {required: true, message: '请输入公众号链接', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入公众号链接"
              v-model="addOfficalAccountLink.src">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本" prop="text"
                      :rules="[
                        {required: true, message: '请输入公众号链接', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入公众号的链接文本"
              v-model="addOfficalAccountLink.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小" prop="text"
                      :rules="[
                        {required: true, message: '请输入链接文本字体大小', trigger: 'blur'}
                        ]">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addOfficalAccountLink.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddOfficalAccountLink = false">取 消</el-button>
        <el-button type="primary" @click="doAddOfficalAccountLink('addOfficalAccountLinkForm')">插入文章</el-button>
      </span>
    </el-dialog>

    <!--    插入视频号主页框-->
    <el-dialog
        title="插入视频主页"
        :visible.sync="showAddShipinhaoIndex"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addShipinhaoIndex">
        <el-form-item label="视频号ID">
          <el-input
              clearable
              placeholder="请输入视频号ID"
              v-model="addShipinhaoIndex.finderUserName">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入视频号的链接文本"
              v-model="addShipinhaoIndex.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addShipinhaoIndex.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddShipinhaoIndex = false">取 消</el-button>
        <el-button type="primary" @click="doAddShipinhaoTopIndex">插入顶部</el-button>
        <el-button type="primary" @click="doAddShipinhaoIndex">插入文章</el-button>
      </span>
    </el-dialog>

    <!--    插入定位 -->
    <el-dialog
        title="插入定位(只支持腾讯地图坐标)"
        :visible.sync="showAddCoord"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="coord" ref="coordForm">
        <el-form-item label="坐标" prop="lnglat"
                      :rules="[
                        {required: true, message: '请输入坐标', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入坐标"
              v-model="coord.lnglat">
          </el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address"
                      :rules="[
                        {required: true, message: '请输入地址', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入地址"
              v-model="coord.address">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小" prop="size"
                      :rules="[
                        {required: true, message: '请输入字体大小', trigger: 'blur'}
                        ]">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="coord.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCoord = false">取 消</el-button>
        <el-button type="primary" size="small" icon="el-icon-check"
                   @click="insertLocationToTitle('coordForm')">插入标题</el-button>
        <el-button type="primary" size="small" icon="el-icon-check"
                   @click="insertLocation('coordForm')">插入文章</el-button>
      </span>
    </el-dialog>

    <!-- 设置资源宽高 -->
    <el-dialog
        title="设置宽高"
        :visible.sync="showResourceProportion"
        width="30%"
        center>
      <el-form :model="resourceProportion" label-width="150px" ref="ResourceProportionForm">
        <el-form-item label="宽度类型" prop="widthType">
          <el-select v-model="resourceProportion.widthType">
            <el-option
                v-for="item in widthHeightType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.widthType==='1'" label="自定义宽度" prop="width"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.width" type="number"></el-input>
        </el-form-item>
        <el-form-item label="高度类型" prop="heightType">
          <el-select v-model="resourceProportion.heightType">
            <el-option
                v-for="item in widthHeightType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.heightType==='1'" label="自定义高度" prop="height"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.height" type="number"></el-input>
        </el-form-item>
        <el-form-item label="圆角" prop="borderRadius"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.borderRadius" type="number"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button :disabled="resourceLoading" type="primary" icon="el-icon-check"
                     @click="insertResource('ResourceProportionForm')">插入文章</el-button>
        </span>
    </el-dialog>

    <!--    插入佣金转账链接 -->
    <el-dialog
        title="佣金支付"
        :visible.sync="showAddScoreLink"
        width="30%"
        center>

      <el-form :model="addScoreLink" label-width="150px" ref="ScoreLinkForm">
        <el-form-item label="支付佣金" prop="score"
                      :rules="[
                      { required: true, message: '不能为空'},
                      { validator: notLeNum0, trigger: 'blur' },
                      ]">
          <el-input v-model="addScoreLink.score" type="number"></el-input>
        </el-form-item>
        <el-form-item label="接收者用户ID" prop="payId"
                      :rules="[
                      { required: true, message: '不能为空'},
                      { type: 'number', message: '必须为数字值'},
                      { validator: notLtNum1, trigger: 'blur' }
                      ]">
          <el-input v-model.number="addScoreLink.payId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接文本" prop="text"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请输入链接文本"
              v-model="addScoreLink.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小" prop="size"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              type="number"
              placeholder="请输入链接字体大小"
              v-model="addScoreLink.size">
          </el-input>
        </el-form-item>
        <el-form-item label="字体颜色" prop="color"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-color-picker v-model="addScoreLink.color"></el-color-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" icon="el-icon-check"
                   @click="insertScoreLink('ScoreLinkForm')">插入文章</el-button>
      </span>

    </el-dialog>

    <!--    插入佣金转账链接 -->
    <el-dialog
        title="卡片佣金支付"
        :visible.sync="showAddCardScoreLink"
        width="30%"
        center
        @closed="onCardScoreDialogClosed">
      <el-button type="primary" @click="uploadResource('uploadCardFileImage')">图片(可多选)<i
          class="el-icon-upload el-icon--right"></i></el-button>
      <el-button type="primary" @click="uploadResource('uploadCardFileVideo')">视频<i
          class="el-icon-upload el-icon--right"></i></el-button>
      <div v-for="(e,i) in addCardScoreLink.resources" :key="i">
        <span v-if="e.type==='image'">
          <img :src="e.src" width="100px" height="100px">
        </span>
        <span v-else>
          <video :src="e.src" width="100px" height="150px"></video>
        </span>
        <el-button v-if="i!==0" type="info" size="mini" icon="el-icon-top" circle
                   @click="moveResource(i, true)"></el-button>
        <el-button v-if="i!==addCardScoreLink.resources.length-1" type="info" size="mini" icon="el-icon-bottom" circle
                   @click="moveResource(i, false)"></el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="onShowDelCardResource(i)"></el-button>
      </div>
      <input
          type="file"
          accept="image/*"
          name="file"
          multiple
          ref="uploadCardFileImage"
          id="uploadCardFileImage"
          @change="changeCardImage"
          style="opacity: 0; width: 0; height: 0; cursor: pointer"
      />
      <input
          type="file"
          accept="video/*"
          name="file"
          ref="uploadCardFileVideo"
          id="uploadCardFileVideo"
          @change="changeCardVideo"
          style="opacity: 0; width: 0; height: 0; cursor: pointer"
      />
      <el-form :model="addCardScoreLink" label-width="150px" ref="CardScoreLinkForm">
        <el-form-item label="背景颜色" prop="backgroundColor"
                      :rules="[
                    { required: true, message: '不能为空'},
                    ]">
          <el-color-picker v-model="addCardScoreLink.backgroundColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="标题" prop="title"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请输入标题"
              v-model="addCardScoreLink.title"
              maxlength="20"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="标题距离" prop="titleLetterSpacing"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              placeholder="请输入标题间距"
              type="number"
              v-model="addCardScoreLink.titleLetterSpacing">
          </el-input>
        </el-form-item>
        <el-form-item label="简介" prop="intro"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              type="textarea"
              clearable
              placeholder="请输入简介"
              v-model="addCardScoreLink.intro">
          </el-input>
        </el-form-item>
        <el-form-item label="简介距离" prop="introLetterSpacing"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              placeholder="请输入简介间距"
              type="number"
              v-model="addCardScoreLink.introLetterSpacing">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
              clearable
              placeholder="用户支付需要依靠备注信息确认产品"
              v-model="addCardScoreLink.remark">
          </el-input>
        </el-form-item>
        <el-form-item label="原价佣金" prop="originScore">
          <el-input v-model="addCardScoreLink.originScore" type="number"></el-input>
        </el-form-item>
        <el-form-item label="原价佣金字体大小" prop="originScoreSize"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              placeholder="请输入原价佣金字体大小"
              type="number"
              v-model="addCardScoreLink.originScoreSize">
          </el-input>
        </el-form-item>
        <el-form-item label="现价佣金" prop="score">
          <el-input v-model="addCardScoreLink.score" type="number"></el-input>
        </el-form-item>
        <el-form-item label="现价佣金字体大小" prop="scoreSize"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              placeholder="请输入现价佣金字体大小"
              type="number"
              v-model="addCardScoreLink.scoreSize">
          </el-input>
        </el-form-item>
        <el-form-item label="市场价" prop="marketplaceprice">
          <el-input v-model="addCardScoreLink.marketplaceprice" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="市场价格名" prop="priceName">
          <el-input
              clearable
              placeholder="如:￥、$"
              v-model="addCardScoreLink.pricename">
          </el-input>
        </el-form-item>
        <el-form-item label="市场价字体大小" prop="marketplacepriceSize"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              placeholder="请输入市场价字体大小"
              type="number"
              v-model="addCardScoreLink.marketplacepriceSize">
          </el-input>
        </el-form-item>
        <el-form-item label="是否显示支付" prop="ispay">
          <el-select v-model="addCardScoreLink.isshowpay" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否支付" prop="ispay">
          <el-select v-model="addCardScoreLink.ispay" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付提示" prop="ishint">
          <el-select v-model="addCardScoreLink.ishint" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容" prop="hint">
          <el-input
              clearable
              placeholder="请输入提示内容"
              v-model="addCardScoreLink.hint">
          </el-input>
        </el-form-item>
        <el-form-item label="接收者用户ID" prop="payid">
          <el-input v-model.number="addCardScoreLink.payid" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" icon="el-icon-check" @click="insertCardScoreLink('CardScoreLinkForm')">插入文章</el-button>
      </span>
    </el-dialog>

    <!-- 删除资源 -->
    <el-dialog
        title="提示"
        :visible.sync="showDelCardResource"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelCardResource = false">取 消</el-button>
        <el-button type="primary" @click="doDelCardResource">确 定</el-button>
      </span>
    </el-dialog>

    <DialogUploadResourceCollections
        :dialog="DialogUploadResourceCollections"
        :resource-collections="resourceCollections"
        @insert-resource="insertResourceCollections"
    ></DialogUploadResourceCollections>

  </div>
</template>

<script>

import {Message} from "element-ui";
import adminGetNewsContentById from "@/api/user/admin-controler/adminGetNewsContentById";
import getAliyunOssSign from "@/api/common/getAliyunOssSign"; // 引用
import Axios from 'axios';
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";
import adminAddEditNews from "@/api/user/admin-controler/adminAddEditNews";
import delMoreTitleById from "@/api/moreTitle/delMoreTitleById";
import {dateFormatToYMDHMS} from "@/utils/time";
import {notLeNum0, notLtNum0, notLtNum1} from "@/utils/check";
import {formatAgencyAreaDetails} from "@/utils/areaDetails";
import listAreas from "@/api/area/list";
import MyEditor from "@/components/MyEditor/MyEditor.vue";
import addNewsListNewsTypes from "@/api/news/addEditNews/addNewsListNewsTypes";
import DialogUploadResourceCollections from "@/components/dialog/MyEditor/DialogUploadResourceCollections.vue";

export default {
  name: "AddEditNews",
  components: {DialogUploadResourceCollections, MyEditor},
  data() {
    return {
      activeCollapse: ['basic', 'style', 'insert'],
      uploadData: {  //提交到OSS的参数
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
      },
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,

      displays:[
        {
          value:'是',
          label:'是',
        },
        {
          value:'否',
          label:'否',
        },
      ],
      params: {
        id: this.$route.query.id || undefined,
        title: undefined,
        titleColor: '#000000',
        fixd:'是',
        fixdLock:'是',
        desc:'',
        datetime: new Date(),
        areaId: undefined,
        coverColor: '#FFFFFF',
        backColor: '#FFFFFF',
        titleAddress: undefined,
        titleLng: undefined,
        titleLat: undefined,
        isShowServerQRCode: '是',
        isDefaultServerQRCode: '是',
        serverQRCode: '',
        coverImg: undefined,
        company: undefined,
        contact: undefined,
        fixedPhone: undefined,
        phone: undefined,
        onlineStore: undefined,
        content: '',
        newsTypeId: undefined,
      },
      moreTitles:[],
      videoIndex: {
        finderUserName: undefined,
        linkText: undefined,
      },
      video: {
        finderUserName: undefined,
        feedId: undefined,
        linkText: undefined,
      },
      loading: false,
      resourceLoading:false,
      newsTypes: [],
      areaDetails:[],

      showResourceProportion:false,
      resourceFile:undefined,
      resourceType:undefined,
      resourceProportion:{
        widthType:'0',
        width:100,
        heightType:'0',
        height:100,
        borderRadius:0,
      },
      widthHeightType:[
        {
          value:'0',
          label:'原比例'
        },
        {
          value:'1',
          label:'自定义'
        },
      ],
      //即将替换的资源样式
      replaceResourceMap:new Map(),
      //原有的资源：  路径后缀 : 属性
      originResourceUrlsMap:new Map(),


      location: '',
      keyword: '',
      center: {lng: 111.752912, lat: 40.832246},
      zoom: 12,
      mapVisible:false,
      locData:{
        longitude:'',
        latitude:'',
        address:'',
        size:20,
      },

      //富文本离开前的焦点位置
      length: 0,

      showAddScoreLink: false,
      addScoreLink:{
        score:undefined,
        payId:undefined,
        text:'【下单】',
        size:20,
        color:'#0000FF',
      },

      cardScoreLinkNode: null,
      showAddCardScoreLink:false,
      addCardScoreLink:{
        resources:[],
        backgroundColor: '#f2f6ff',
        title:undefined,
        titleLetterSpacing: 4,
        intro:undefined,
        introLetterSpacing: 1,
        remark:undefined,
        originScore:undefined,
        originScoreSize: 10,
        score:undefined,
        scoreSize: 14,
        marketplaceprice:undefined,
        pricename:'元',
        marketplacepriceSize: 14,
        isshowpay:'是',
        ispay:'是',
        ishint: '否',
        hint: '',
        payid:undefined,
      },
      showDelCardResource:false,
      delCardResourceIndex:undefined,

      showAddWeChatMP: false,
      addWeChatMP: {
        appid: undefined,
        text: '点击进入小程序',
        size: 20,
      },
      weChatMP:{
        appid: undefined,
        text: undefined,
      },
      showAddShipinhaoIndex: false,
      addShipinhaoIndex: {
        finderUserName: undefined,
        text: '点击进入视频主页',
        size: 20,
      },
      showAddShipinhao: false,
      addShipinhao: {
        finderUserName: undefined,
        feedId: undefined,
        text: '点击观看视频',
        size: 20,
      },

      showAddOfficalAccountLink:false,
      addOfficalAccountLink:{
        src:'',
        text:'点击打开公众号',
        size: 20,
      },

      showAddCoord:false,
      coord:{
        lnglat:'',
        address:'',
        size:20,
      },

      DialogUploadResourceCollections:false,
      resourceCollectionsNode: null,
      resourceCollections: {
        width:100,
        heightType:'0',
        height:100,
        borderRadius:0,
        numberColor:'#FF0000',
        resources:[],
      },

    }
  },

  methods: {
    notLeNum0,
    notLtNum1,
    notLtNum0,

    insertResourceCollections(resourceProportion){
      const value = JSON.stringify(resourceProportion).replaceAll('"', '\'')
      // let html = '<a style="font-size: 20px;color: blue;" href="javascript:void(0)" contenteditable="true" class="card-score-link" value="' + value + '">' + this.addCardScoreLink.title + '</a>'

      const aNode = document.createElement('a')
      aNode.style.color = '#06c'
      aNode.style.textDecoration = 'underline'
      aNode.style.cursor = 'pointer'

      aNode.classList.add('resource-collections')
      aNode.setAttribute('href', 'javascript:void(0)')
      aNode.setAttribute('contenteditable', 'false')
      aNode.setAttribute('value', value)
      aNode.innerText = '【图集】'

      if (this.resourceCollectionsNode) {
        // 修改
        this.resourceCollectionsNode.parentNode.replaceChild(aNode, this.resourceCollectionsNode)
      } else {
        const divNode = document.createElement('div')
        divNode.classList.add('resource-collections')
        divNode.appendChild(aNode)
        this.$refs.MyEditor.insertNode(divNode)
      }

      this.DialogUploadResourceCollections = false
    },
    resourceCollectionsClickListener(target) {
      if (!target || !target.getAttribute) {
        return
      }
      this.resourceCollectionsNode = target
      const resourceCollections = JSON.parse(target.getAttribute('value').replaceAll('\'', '"'))
      for (let resource of resourceCollections.resources) {
        if (!resource.src.startsWith(this.fileBaseUrl)) {
          resource.src = this.fileBaseUrl + resource.src
        }
      }
      this.resourceCollections = resourceCollections
      this.DialogUploadResourceCollections = true
    },
    insertCardScoreLink(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addCardScoreLink.resources.length===0){
            return Message({message:'请至少上传一张图片或视频',type:"error",duration:3000})
          }
          console.log(this.addCardScoreLink)
          const value = JSON.stringify(this.addCardScoreLink).replaceAll('"', '\'')
          // let html = '<a style="font-size: 20px;color: blue;" href="javascript:void(0)" contenteditable="true" class="card-score-link" value="' + value + '">' + this.addCardScoreLink.title + '</a>'

          const aNode = document.createElement('a')
          aNode.style.color = '#06c'
          aNode.style.textDecoration = 'underline'
          aNode.style.cursor = 'pointer'

          aNode.classList.add('card-score-link')
          aNode.setAttribute('href', 'javascript:void(0)')
          aNode.setAttribute('contenteditable', 'false')
          aNode.setAttribute('value', value)
          aNode.innerText = this.addCardScoreLink.title

          if (this.cardScoreLinkNode) {
            // 修改
            this.cardScoreLinkNode.parentNode.replaceChild(aNode, this.cardScoreLinkNode)
          } else {
            const divNode = document.createElement('div')
            divNode.classList.add('card-score-link')
            divNode.appendChild(aNode)
            this.$refs.MyEditor.insertNode(divNode)
          }

          this.$refs.MyEditor.normalizeSpecialBlocks()
          this.showAddCardScoreLink=false
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    cardScoreLinkClickListener(target) {
      if (!target || !target.getAttribute) {
        return
      }
      this.cardScoreLinkNode = target
      let addCardScoreLink = JSON.parse(target.getAttribute('value').replaceAll('\'', '"'))
      for (let resource of addCardScoreLink.resources) {
        if (!resource.src.startsWith(this.fileBaseUrl)) {
          resource.src = this.fileBaseUrl + resource.src
        }
      }
      addCardScoreLink.backgroundColor = addCardScoreLink.backgroundColor ? addCardScoreLink.backgroundColor : '#f2f6ff'
      addCardScoreLink.titleLetterSpacing = addCardScoreLink.titleLetterSpacing ? addCardScoreLink.titleLetterSpacing : 4
      addCardScoreLink.introLetterSpacing = addCardScoreLink.introLetterSpacing ? addCardScoreLink.introLetterSpacing : 1
      addCardScoreLink.originScoreSize = addCardScoreLink.originScoreSize ? addCardScoreLink.originScoreSize : 10
      addCardScoreLink.scoreSize = addCardScoreLink.scoreSize ? addCardScoreLink.scoreSize : 14
      addCardScoreLink.marketplacepriceSize = addCardScoreLink.marketplacepriceSize ? addCardScoreLink.marketplacepriceSize : 14
      addCardScoreLink.ishint = addCardScoreLink.ishint ? addCardScoreLink.ishint : '否'
      this.addCardScoreLink = addCardScoreLink
      this.showAddCardScoreLink = true
    },
    onCardScoreDialogClosed() {
      this.cardScoreLinkNode = null
      this.$nextTick(() => {
        if (this.$refs.MyEditor) {
          this.$refs.MyEditor.normalizeSpecialBlocks()
          this.$refs.MyEditor.focusEditor()
        }
      })
    },
    doDelCardResource(){
      const newArr = []
      for (let i=0;i<this.addCardScoreLink.resources.length;i++){
        if (i === this.delCardResourceIndex) continue
        newArr.push(this.addCardScoreLink.resources[i])
      }
      this.addCardScoreLink.resources=newArr
      this.showDelCardResource=false
    },
    onShowDelCardResource(i){
      this.delCardResourceIndex = i
      this.showDelCardResource = true
    },
    moveResource(i,isUp){
      const newArr = JSON.parse(JSON.stringify(this.addCardScoreLink.resources))
      const box = newArr[i]
      if (isUp){
        newArr[i]=newArr[i-1]
        newArr[i-1]=box
      }else{
        newArr[i]=newArr[i+1]
        newArr[i+1]=box
      }
      this.addCardScoreLink.resources=newArr
    },
    changeCardImage(fileEvent){
      this.changeResource(fileEvent, 'image')
    },
    changeCardVideo(fileEvent){
      this.changeResource(fileEvent, 'video')
    },
    changeResource(fileEvent, type){
      const files = fileEvent.target.files
      if (!files || !files.length) {
        return
      }
      const fileList = type === 'image' ? Array.from(files) : [files[0]]
      fileList.forEach(file => {
        this.uploadCardResource(file, type)
      })
      fileEvent.target.value = ''
    },
    uploadCardResource(file, type){
      getAliyunOssSign("/common/sign").then(response=>{
        let resultObj = response.data;
        let pre = resultObj.dir + '/'+this.getUUID()+'_'
        let data = new FormData();
        data.append("key", pre+'${filename}')
        data.append("OSSAccessKeyId", resultObj.accessid)
        data.append("policy", resultObj.policy)
        data.append("signature", resultObj.signature)
        data.append("file", file)
        data.append("success_action_status", 200)

        let config = {
          'Content-Type': 'multipart/form-data'
        }
        Axios.post(resultObj.host, data, config).then((res)=>{
          if(res.status==200){
            let filepath = pre+file.name
            adminGetFileSignUrl(filepath).then(temp=>{
              this.addCardScoreLink.resources.push({type:type, src:temp.data})
              Message({
                message:"成功",
                type:"success",
                duration:3000
              })
            })
          }
        }).catch(err=>{
          console.error(err)
          Message({
            message: '上传失败',
            type: 'error',
            duration: 3 * 1000
          });
        })
      });
    },
    uploadResource(id){
      document.getElementById(id).click();
    },
    delMoreTitle(moreTitle){
      let data = []
      let moreTitles = this.moreTitles
      if (!moreTitle.id){
        for (let i=0;i<moreTitles.length;i++){
          if (moreTitles[i].uuid !== moreTitle.uuid) data.push(moreTitles[i])
        }
      }else{
        for (let i=0;i<moreTitles.length;i++){
          if (moreTitles[i].id !== moreTitle.id) data.push(moreTitles[i])
        }
        delMoreTitleById(moreTitle.id).then(res=>{
          if (res.code===1){
            Message({message:'成功',type:"success",duration:3000})
          }
        })
      }
      this.moreTitles=data
    },
    addMoreTitle(){
      let moreTitle = {
        title:undefined,
        color:'#000000',
        display:'是',
        type:'1',
        uuid:this.getUUID()
      }
      this.moreTitles.push(moreTitle)
    },
    newsTypeChange(e){
      if(!e||e.length==0){
        this.params.newsTypeId=undefined
      }else{
        this.params.newsTypeId=e[e.length-1]
      }
    },
    doAddWeChatMPTop(){
      let addWeChatMP = this.addWeChatMP
      if(!addWeChatMP.appid){
        return Message({
          message:'请输入AppId',
          type:"error",
          duration:3000
        })
      }
      if(!addWeChatMP.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      this.weChatMP.appid=addWeChatMP.appid
      this.weChatMP.text=addWeChatMP.text
    },
    doAddWeChatMP(){
      let addWeChatMP = this.addWeChatMP
      if(!addWeChatMP.appid){
        return Message({
          message:'请输入AppId',
          type:"error",
          duration:3000
        })
      }
      if(!addWeChatMP.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      // let html = '<a style="font-size: ' + addWeChatMP.size + 'px" class="wechatmp-link" href="javascript:void(0)" contenteditable="true" value="' + addWeChatMP.appid + '">' + addWeChatMP.text + '</a>'

      const aNode = document.createElement('a')
      aNode.style.color = '#06c'
      aNode.style.textDecoration = 'underline'
      aNode.style.cursor = 'pointer'

      aNode.style.fontSize = addWeChatMP.size + 'px'
      aNode.classList.add('wechatmp-link')
      aNode.href = 'javascript:void(0)'
      aNode.contentEditable = 'true'
      aNode.setAttribute('value', addWeChatMP.appid)
      aNode.innerText = addWeChatMP.text
      const divNode = document.createElement('div')
      divNode.appendChild(aNode)
      this.$refs.MyEditor.insertNode(divNode)
    },
    doAddShipinhaoTopIndex(){
      let addShipinhaoIndex = this.addShipinhaoIndex
      if(!addShipinhaoIndex.finderUserName){
        return Message({
          message:'请输入视频号ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhaoIndex.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      this.videoIndex.finderUserName=addShipinhaoIndex.finderUserName
      this.videoIndex.linkText=addShipinhaoIndex.text
    },
    doAddShipinhaoTop(){
      let addShipinhao = this.addShipinhao
      if(!addShipinhao.finderUserName){
        return Message({
          message:'请输入视频号ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhao.feedId){
        return Message({
          message:'请输入视频ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhao.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      this.video.finderUserName=addShipinhao.finderUserName
      this.video.feedId=addShipinhao.feedId
      this.video.linkText=addShipinhao.text
    },
    doAddShipinhaoIndex(){
      let addShipinhaoIndex = this.addShipinhaoIndex
      if(!addShipinhaoIndex.finderUserName){
        return Message({
          message:'请输入视频号ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhaoIndex.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      // let html = '<a style="font-size: ' + addShipinhaoIndex.size + 'px" class="shipinhaoindex-link" href="javascript:void(0)" contenteditable="true" value="' + addShipinhaoIndex.finderUserName + '">' + addShipinhaoIndex.text + '</a>'

      const aNode = document.createElement('a')
      aNode.style.color = '#06c'
      aNode.style.textDecoration = 'underline'
      aNode.style.cursor = 'pointer'

      aNode.style.fontSize = addShipinhaoIndex.size + 'px'
      aNode.classList.add('shipinhaoindex-link')
      aNode.href = 'javascript:void(0)'
      aNode.contentEditable = 'true'
      aNode.setAttribute('value', addShipinhaoIndex.finderUserName)
      aNode.innerText = addShipinhaoIndex.text
      const divNode = document.createElement('div')
      divNode.appendChild(aNode)
      this.$refs.MyEditor.insertNode(divNode)
    },
    doAddShipinhao(){
      let addShipinhao = this.addShipinhao
      if(!addShipinhao.finderUserName){
        return Message({
          message:'请输入视频号ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhao.feedId){
        return Message({
          message:'请输入视频ID',
          type:"error",
          duration:3000
        })
      }
      if(!addShipinhao.text){
        return Message({
          message:'请输入链接文本',
          type:"error",
          duration:3000
        })
      }

      // let html = '<a style="font-size: ' + addShipinhao.size + 'px" class="shipinhao-link" href="javascript:void(0)" contenteditable="true" value="' + addShipinhao.finderUserName + ',' + addShipinhao.feedId + '">' + addShipinhao.text + '</a>'
      const aNode = document.createElement('a')
      aNode.style.color = '#06c'
      aNode.style.textDecoration = 'underline'
      aNode.style.cursor = 'pointer'

      aNode.style.fontSize = addShipinhao.size + 'px'
      aNode.classList.add('shipinhao-link')
      aNode.href = 'javascript:void(0)'
      aNode.contentEditable = 'true'
      aNode.setAttribute('value', addShipinhao.finderUserName + ',' + addShipinhao.feedId)
      aNode.innerText = addShipinhao.text
      const divNode = document.createElement('div')
      divNode.appendChild(aNode)
      this.$refs.MyEditor.insertNode(divNode)
    },
    doAddOfficalAccountLink(formName){
      this.$refs[formName].validate((valid) => {
        const addOfficalAccountLink = this.addOfficalAccountLink
        const aNode = document.createElement('a')
        aNode.style.color = '#06c'
        aNode.style.textDecoration = 'underline'
        aNode.style.cursor = 'pointer'

        aNode.style.fontSize = addOfficalAccountLink.size + 'px'
        aNode.classList.add('offical-account-link')
        aNode.href = 'javascript:void(0)'
        aNode.contentEditable = 'true'
        aNode.setAttribute('value', addOfficalAccountLink.src)
        aNode.innerText = addOfficalAccountLink.text
        const divNode = document.createElement('div')
        divNode.appendChild(aNode)
        this.$refs.MyEditor.insertNode(divNode)
        if (valid) {
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    insertScoreLink(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addScoreLink)
          const addScoreLink = JSON.parse(JSON.stringify(this.addScoreLink))
          // let html = '<a style="font-size: ' + addScoreLink.size + 'px;color: ' + addScoreLink.color + ';" class="score-link" href="javascript:void(0)" contenteditable="true" value="' + addScoreLink.score + ',' + addScoreLink.payId + '">' + addScoreLink.text + '</a>'

          const aNode = document.createElement('a')
          aNode.style.color = '#06c'
          aNode.style.textDecoration = 'underline'
          aNode.style.cursor = 'pointer'

          aNode.style.fontSize = addScoreLink.size + 'px'
          aNode.style.color = addScoreLink.color
          aNode.classList.add('score-link')
          aNode.href = 'javascript:void(0)'
          aNode.contentEditable = 'true'
          aNode.setAttribute('value', addScoreLink.score + ',' + addScoreLink.payId)
          aNode.innerText = addScoreLink.text

          const divNode = document.createElement('div')
          divNode.appendChild(aNode)
          this.$refs.MyEditor.insertNode(divNode)

          this.showAddScoreLink=false
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowAddScoreLink(){
      this.showAddScoreLink = true
    },
    onShowAddCardScoreLink(){
      this.cardScoreLinkNode = null
      this.addCardScoreLink = {
        resources: [],
        backgroundColor: '#f2f6ff',
        title: undefined,
        titleLetterSpacing: 1,
        intro: undefined,
        introLetterSpacing: 4,
        remark: undefined,
        originScore: undefined,
        originScoreSize: 10,
        score: undefined,
        scoreSize: 14,
        pricename: '元',
        marketplaceprice: undefined,
        marketplacepriceSize: 14,
        isshowpay: '是',
        ispay: '是',
        ishint: '否',
        hint: '',
        payid: undefined,
      }
      this.showAddCardScoreLink=true
    },
    onShowDialogUploadResourceCollections(){
      this.resourceCollectionsNode = null
      this.resourceCollections = {
        width:100,
        heightType:'0',
        height:100,
        borderRadius:0,
        numberColor:'#FF0000',
        resources:[],
      }
      this.DialogUploadResourceCollections = true
    },
    onShowAddWeChatMP(){
      this.showAddWeChatMP = true
    },
    onShowAddShipinhaoIndex(){
      this.showAddShipinhaoIndex=true
    },
    onShowAddShipinhao(){
      this.showAddShipinhao=true
    },
    onShowAddOfficalAccountLink(){
      this.showAddOfficalAccountLink=true
    },
    positioning(){
      this.showAddCoord = true


      // this.mapVisible = true
    },
    handler ({BMap, map}) {
      let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        console.log(r);
        _this.center = {lng: r.longitude, lat: r.latitude};   // 设置center属性值
        _this.autoLocationPoint = {lng: r.longitude, lat: r.latitude};  // 自定义覆盖物
        _this.initLocation = true;
      },{enableHighAccuracy: true})
      window.map = map;
      window.BMap = BMap;
    },
    //点击地图监听
    clickEvent(e){
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("https://hl-tianxia.oss-cn-chengdu.aliyuncs.com/upload/common/map.png", new window.BMap.Size(64, 64), {anchor: new window.BMap.Size(18, 32),imageSize: new window.BMap.Size(36, 25)});
      let myMarker = new window.BMap.Marker(new window.BMap.Point(e.point.lng, e.point.lat),{icon: Icon_0});
      window.map.addOverlay(myMarker);
      //用所定位的经纬度查找所在地省市街道等信息
      let point = new window.BMap.Point(e.point.lng, e.point.lat);
      let gc = new window.BMap.Geocoder();
      let _this = this;
      gc.getLocation(point, function (rs) {
        _this.locData.address = rs.address;

      });
      this.locData.longitude = e.point.lng;
      this.locData.latitude = e.point.lat;
    },

    //清空标记
    clearMarker(){
      let keyword = this.keyword
      let location = this.location
      this.keyword = keyword+'a'
      this.location = location+'a'
      let that = this
      let timer = setInterval(function () {
        that.keyword = keyword
        that.location = location
        clearInterval(timer)
      },1000)
      this.locData = {
        longitude:'',
        latitude:'',
        address:'',
      }
    },

    //定位成功回调
    getLoctionSuccess(point){
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("https://hl-tianxia.oss-cn-chengdu.aliyuncs.com/upload/common/map.png", new window.BMap.Size(64, 64), {anchor: new window.BMap.Size(18, 32),imageSize: new window.BMap.Size(36, 36)});
      let myMarker = new window.BMap.Marker(new window.BMap.Point(point.point.lng, point.point.lat),{icon: Icon_0});
      window.map.addOverlay(myMarker);
      this.locData.longitude = point.point.lng;
      this.locData.latitude = point.point.lat;
    },

    insertLocationToTitle(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length!=2) return Message({message:'请正确输入坐标',type:"error",duration:3000})
          this.params.titleLng = lnglat[1]
          this.params.titleLat = lnglat[0]
          this.params.titleAddress = this.coord.address
          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },

    //插入位置
    insertLocation(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length!=2) return Message({message:'请正确输入坐标',type:"error",duration:3000})
          // let html = '<a class="address" href="javascript:void(0)" contenteditable="true" style="font-size: ' + this.coord.size + 'px" value="' + lnglat[1] + ',' + lnglat[0] + '">' + this.coord.address + '</a>'
          const aNode = document.createElement('a')
          aNode.style.color = '#06c'
          aNode.style.textDecoration = 'underline'
          aNode.style.cursor = 'pointer'

          aNode.classList.add('address')
          aNode.href = 'javascript:void(0)'
          aNode.contentEditable = 'true'
          aNode.setAttribute('value', lnglat[1] + ',' + lnglat[0])
          aNode.innerText = this.coord.address
          aNode.style.fontSize = this.coord.size + 'px'

          const divNode = document.createElement('div')
          divNode.appendChild(aNode)
          this.$refs.MyEditor.insertNode(divNode)

          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },

    doConfirm(){
      if(!this.params.title){
        return Message({
          message: '请输入标题',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if(!this.params.titleColor){
        return Message({
          message: '请选择标题颜色',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if(!this.params.datetime){
        return Message({
          message: '请选择时间',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if(!this.params.newsTypeId){
        return Message({
          message: '请选择企业类型',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if(!this.params.coverImg){
        return Message({
          message: '请上传封面图片',
          type: 'error',
          duration: 3 * 1000
        });
      }

      this.loading=true

      const params = JSON.parse(JSON.stringify(this.params))
      params.coverImg = params.coverImg.substring(this.fileBaseUrl.length).substring(1)
      let coverImg = params.coverImg.split("?")[0]
      params.coverImg = decodeURIComponent(coverImg)

      if (params.serverQRCode){
        params.serverQRCode = params.serverQRCode.substring(this.fileBaseUrl.length+1)
        let serverQRCode = params.serverQRCode.split("?")[0]
        params.serverQRCode = serverQRCode
      }

      let content = this.$refs.MyEditor.getContent()
      content = content.replaceAll(this.fileBaseUrl, "")
      let rex = /upload\/temp\/[.\w\d-?=&;%\u4E00-\u9FFF/]*/g
      let result = undefined
      let arr = new Set()
      while((result = rex.exec(content)) != null) {
        arr.add(result[0])
      }

      arr.forEach(e=>{
        content = content.replaceAll(e, decodeURIComponent(e.split("?")[0]))
      })
      params.content = content
      if(this.video.finderUserName&&this.video.feedId&&this.video.linkText) {
        params.video = this.video.finderUserName + ',' + this.video.feedId + ',' + this.video.linkText
      }
      if(this.video.linkText==''){
        params.video = ''
      }
      if(this.videoIndex.finderUserName&&this.videoIndex.linkText) {
        params.videoIndex = this.videoIndex.finderUserName + ',' + this.videoIndex.linkText
      }
      if(this.videoIndex.linkText==''){
        params.videoIndex = ''
      }
      if(this.weChatMP.appid&&this.weChatMP.text) {
        params.weChatMP = this.weChatMP.appid + ',' + this.weChatMP.text
      }
      if(this.weChatMP.text==''){
        params.weChatMP = ''
      }

      if(params.areaDetailId && params.areaDetailId.length===3){
        params.provinceId=params.areaDetailId[0]
        params.cityId=params.areaDetailId[1]
        params.areaId=params.areaDetailId[2]
      }else{
        params.provinceId=undefined
        params.cityId=undefined
        params.areaId=undefined
      }

      params.moreTitles=this.moreTitles

      params.datetime = dateFormatToYMDHMS(new Date(params.datetime))

      adminAddEditNews(params).then(res=>{
        if(res.code!=1){
          if(res.data){
            if(res.data.title){
              Message({
                message: res.data.title,
                type: 'error',
                duration: 3 * 1000
              });
            }
            if(res.data.coverImg){
              Message({
                message: res.data.coverImg,
                type: 'error',
                duration: 3 * 1000
              });
            }
            if(res.data.newsTypeId){
              Message({
                message: res.data.newsTypeId,
                type: 'error',
                duration: 3 * 1000
              });
            }
            if (res.data.illError) {
              Message({
                message: res.data.illError,
                type: 'error',
                duration: 3 * 1000
              });
            }
          }
        }else {
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
        }
        this.loading=false
      })
    },
    async beforeAvatarUpload() {
      this.loading=true
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData.policy = resultObj.policy;
        this.uploadData.signature = resultObj.signature;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
        this.uploadData.dir = resultObj.dir;
        this.uploadData.host = resultObj.host;
      });
      return true
    },
    ServerQRCodeHandleAvatarSuccess(response, file) {
      adminGetFileSignUrl(this.uploadData.key.replace("${filename}", file.name)).then(res => {
        this.params.serverQRCode = res.data
        this.loading = false
      })
    },
    handleAvatarSuccess(response, file) {
      adminGetFileSignUrl(this.uploadData.key.replace("${filename}",file.name)).then(res=>{
        this.params.coverImg = res.data
        this.loading=false
      })
    },

    onEditorChange(event) {
      let html = event.html
      html = html.replaceAll('div','p')
      this.params.content = html
    },
    onEditorBlur(quill){
      let sel = quill.getSelection()
      if(sel){
        let index = sel.index
        if(index){
          return this.length = index
        }
      }
      this.length=this.params.content.length
    },
    onEditorFocus(){
      // this.length = quill.getSelection().index
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    insertResource(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadFile(this.resourceFile, this.resourceType)
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    resouceProportion(file,type){
      this.resourceFile=file
      this.resourceType=type
      this.showResourceProportion=true
    },
    //上传视频到服务器
    changeimage(file) {
      this.resouceProportion(file,  'image')
    },

    //上传图片到服务器
    changevideo(file) {
      this.resouceProportion(file,  'video')
    },

    uploadFile(file, type){
      this.loading=true
      this.resourceLoading=true
      getAliyunOssSign("/common/sign").then(response=>{
        //设置相关的参数
        let resultObj = response.data;
        //上传的文件名，使用UUID处理一下
        let pre = resultObj.dir + '/'+this.getUUID()+'_'
        file = file.target.files[0];
        let data = new FormData();
        data.append("key", pre+'${filename}')
        data.append("OSSAccessKeyId", resultObj.accessid)
        data.append("policy", resultObj.policy)
        data.append("signature", resultObj.signature)
        data.append("file", file)
        data.append("success_action_status", 200)

        let config = {
          'Content-Type': 'multipart/form-data'
        }
        Axios.post(resultObj.host, data, config).then((res)=>{
          if(res.status==200){
            adminGetFileSignUrl(pre+file.name).then(res=>{
              if(type=='image') {
                this.insertImg("image", res.data);
              }
              if(type=='video'){
                this.insertEle("video", res.data);
              }
              Message({
                message: '上传成功',
                type: 'success',
                duration: 3 * 1000
              });
              this.loading=false
              this.resourceLoading=false
              this.showResourceProportion=false
            })

          }
        }).catch(err=>{
          Message({
            message: '上传失败'+err.getMessage(),
            type: 'error',
            duration: 3 * 1000
          });
          this.loading=false
          this.resourceLoading=false
        })
      });

    },

    processWatchResource(resources){
      const that = this
      const clazz = 'resource-resize'
      resources.forEach(function(img) {
        if (img.classList.contains(clazz)) {
          // 图片已经调整过大小，跳过
          return;
        }
        let src = img.src.toString()+'"'
        // 'https://hltx-test.oss-cn-chengdu.aliyuncs.com/upload/temp/'
        if(src.startsWith(that.fileBaseUrl+'/upload/temp/')){

          let otherStr = ' class="'+clazz+'" style="'

          if (that.resourceProportion.widthType==='1'){
            img.style.width = that.resourceProportion.width + 'px'
            otherStr += 'width: '+that.resourceProportion.width + 'px; '
          }
          if (that.resourceProportion.heightType==='1'){
            img.style.height = that.resourceProportion.height + 'px'
            otherStr += 'height: '+that.resourceProportion.height + 'px; '
          }
          img.style.borderRadius = that.resourceProportion.borderRadius + 'px'
          otherStr += 'border-radius: '+that.resourceProportion.borderRadius + 'px;"'
          img.classList.add(clazz); // 添加标记，表示已调整大小


          //加入即将替换的样式
          src = src.substring(src.length-16, src.length)
          otherStr = src+otherStr.toString()
          that.replaceResourceMap.set(src,otherStr)
        }

        //判断是否是原有图片
        let originSrc = img.src.substring(img.src.length-16)
        if (that.originResourceUrlsMap.has(originSrc)){
          const info = that.originResourceUrlsMap.get(originSrc)
          img.style.width = info.width
          img.style.height = info.height
          img.style.borderRadius = info.borderRadius
          img.style.display = info.display
          img.style.float = info.float
          img.style.margin = info.margin
          img.classList.add(clazz); // 添加标记，表示已调整大小

          let otherStr = ' class="'+clazz+'" style="'
          if (info.width) {
            otherStr += 'width: '+info.width+'; '
          }
          if (info.height) {
            otherStr += 'height: '+info.height+'; '
          }
          otherStr += 'border-radius: '+info.borderRadius+';"'
          //加入即将替换的样式
          originSrc = originSrc.substring(1)+'"'
          otherStr = originSrc+otherStr.toString()
          that.replaceResourceMap.set(originSrc,otherStr)
        }

      });
    },
    watchResource(){
      const videos = document.querySelectorAll('.quill video');
      const images = document.querySelectorAll('.quill img');
      this.processWatchResource(videos)
      this.processWatchResource(images)

      return true
    },

    // 图片上传事件
    insertImg(type, url) {
      const myQuillEditor = this.$refs.myQuillEditor;
      const quill = myQuillEditor.quill
      let length = this.length
      // 插入视频  url为服务器返回的图片地址
      if (type === "image") {
        quill.insertEmbed(length, "image", url);
      } else {
        quill.insertEmbed(length, type, url);
      }
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    //视频上传事件
    insertEle(type, url) {
      let quill = this.$refs.myQuillEditor.quill;
      let length = this.length
      // 插入视频  url为服务器返回的图片地址
      if (type === "video") {
        quill.insertEmbed(length, "simpleVideo", {url,width:'100%',height:'auto',controls:'controls'});
      } else {
        quill.insertEmbed(length, type, url);
      }
      // 调整光标到最后
      quill.setSelection(length + 1);
    },

//处理粘贴事件
    processParse(node, delta){
      let ops = []
      delta.ops.forEach(async (op) => {
        if (
            op.insert && typeof op.insert !== 'string'
            && op.insert.image
            && op.insert.image.includes(';base64')
        ) {  // 如果粘贴了图片，这里会是一个对象
          this.loading=true
          getAliyunOssSign("/common/sign").then(response=>{
            let file = this.dataURLtoFile(op.insert.image, `paste-${Math.random().toString(36).slice(-8)}.png`)
            //设置相关的参数
            let resultObj = response.data;
            //上传的文件名，使用UUID处理一下
            let pre = resultObj.dir + '/'+this.getUUID()+'_'
            let data = new FormData();
            data.append("key", pre+'${filename}')
            data.append("OSSAccessKeyId", resultObj.accessid)
            data.append("policy", resultObj.policy)
            data.append("signature", resultObj.signature)
            data.append("file", file)
            data.append("success_action_status", 200)

            let config = {
              'Content-Type': 'multipart/form-data'
            }
            Axios.post(resultObj.host, data, config).then((res)=>{
              if(res.status==200){
                adminGetFileSignUrl(pre+file.name).then(res=>{
                  this.insertImg("image", res.data);
                  Message({
                    message: '上传成功',
                    type: 'success',
                    duration: 3 * 1000
                  });
                  this.loading=false
                })
              }
            }).catch(err=>{
              Message({
                message: '上传失败'+err.getMessage(),
                type: 'error',
                duration: 3 * 1000
              });
              this.loading=false
            })
          });
        }else{
          ops.push(op)
        }
      })
      delta.ops=ops
      return delta
    },
    dataURLtoFile(dataurl, name) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while(n--){
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], name, {type:mime})
    },
    processExtractResourceInfo(tags){
      // 遍历<img>标签并打印其src属性的值
      tags.forEach(img => {
        const info = {
          width: img.style.width,
          height: img.style.height,
          borderRadius: img.style.borderRadius,
          display: img.style.display,
          float: img.style.float,
          margin: img.style.margin,
        }
        let src = img.src.toString()
        src = src.substring(src.length-16)
        this.originResourceUrlsMap.set(src, info)
      });
    },
    extractResourceInfo(content){
      // 使用DOMParser解析HTML文本
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      // 获取所有<img>标签
      const imgTags = doc.querySelectorAll('img');
      this.processExtractResourceInfo(imgTags)
      const videoTags = doc.querySelectorAll('video');
      this.processExtractResourceInfo(videoTags)
    },
    getAreaDetail(){
      listAreas().then(res=>{
        let areaDetails = formatAgencyAreaDetails(res.data)
        this.areaDetails = areaDetails
      })
    },
    async getNewsType(){
      const newsTypes = await addNewsListNewsTypes()
      this.newsTypes = newsTypes
    },
    getNewsById() {
      if (this.params.id) {
        adminGetNewsContentById(this.params.id).then(res => {
          if (res.code == 1) {
            const news = JSON.parse(JSON.stringify(res.data))
            this.$refs.MyEditor.setContent(news.content.replaceAll("src=\"/upload/news", "src=\"" + this.fileBaseUrl + "/upload/news"))

            news.serverQRCode = news.serverQRCode ? this.fileBaseUrl + news.serverQRCode : ''
            news.coverImg = this.fileBaseUrl + news.coverImg
            const moreTitles = news.moreTitles
            moreTitles.sort((a, b) => a.id - b.id)
            this.moreTitles = moreTitles

            if (news.provinceId && news.cityId && news.areaId) {
              news.areaDetailId = [news.provinceId, news.cityId, news.areaId]
            } else {
              news.areaDetailId = []
            }

            const video = news.video
            if (video) {
              const vs = video.split(',')
              this.video.finderUserName = vs[0]
              this.addShipinhao.finderUserName = vs[0]
              this.video.feedId = vs[1]
              this.addShipinhao.feedId = vs[1]
              this.video.linkText = vs[2]
              this.addShipinhao.linkText = vs[2]
            }
            const videoIndex = news.videoIndex
            if (videoIndex) {
              const vs = videoIndex.split(',')
              this.videoIndex.finderUserName = vs[0]
              this.addShipinhaoIndex.finderUserName = vs[0]
              this.videoIndex.linkText = vs[1]
              this.addShipinhaoIndex.linkText = vs[1]
            }
            const weChatMP = news.weChatMP
            if (weChatMP) {
              const vs = weChatMP.split(',')
              this.weChatMP.appid = vs[0]
              this.addWeChatMP.appid = vs[0]
              this.weChatMP.text = vs[1]
              this.addWeChatMP.text = vs[1]
            }

            this.params = news
          }
        })
      }
    },
    fetchData() {
      this.getAreaDetail()
      this.getNewsType()
      this.getNewsById()
    },
  },

  created() {
    const AddEditNewsId = localStorage.getItem('AddEditNewsId')
    if (AddEditNewsId !== null && AddEditNewsId !== 'undefined') {
      this.params.id = AddEditNewsId
    }
  },
  mounted() {
    this.fetchData()
  },

}
</script>
<style lang="scss" scoped>
@import "news.scss";
@import "font-face.css";
@import "font.css";
</style>
